import { ReactNode } from "react";
import { useAuth } from "@/contexts/authContext";

interface AuthConditionalProps {
  authenticated: ReactNode;
  unauthenticated: ReactNode;
}

export default function AuthConditional({
  authenticated,
  unauthenticated,
}: AuthConditionalProps) {
  const { isAuthenticated } = useAuth();

  return <>{isAuthenticated ? authenticated : unauthenticated}</>;
}
